import { render } from "./Institute.vue?vue&type=template&id=57ea7d02&scoped=true"
import script from "./Institute.vue?vue&type=script&lang=js"
export * from "./Institute.vue?vue&type=script&lang=js"

import "./Institute.vue?vue&type=style&index=0&id=57ea7d02&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57ea7d02"]])

export default __exports__